// 创建 IntersectionObserver 实例
window.YGImageLoader = new IntersectionObserver(
  (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const img = entry.target;
        const newImg = new Image();
        newImg.onload = () => {
          img.src = newImg.src;
          img.removeAttribute("data-src"); // 如果只需要加载一次
          img.removeAttribute("srcset");
          observer.unobserve(img); // 停止观察该元素
        };
        newImg.src = img.getAttribute("data-src");
      }
    });
  },
  {
    rootMargin: "50px", // 预加载距离视口 50px 的图片
  }
);

class YGImage extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    // 这里放置初始化逻辑
    this.loaderImg();
  }

  get images() {
    return this.querySelectorAll("img[data-src]");
  }

  loaderImg() {
    // 这里放置自定义逻辑
    this.images.forEach((img) => {
      window.YGImageLoader.observe(img);
    });
  }
}
if (!window.customElements.get("yg-image")) {
  window.customElements.define("yg-image", YGImage);
}

class YGPopupBox extends HTMLElement {
    constructor() {
      super();
      this.clickClosePopup = this.clickClosePopup.bind(this);
      this.clickOpenPopup = this.clickOpenPopup.bind(this);
      this.$contentInner = null;
    }

    connectedCallback() {
      this.$contentInner = this.querySelector('.yg-popup-box-content-inner');
      this.addEventListener('click', this.clickClosePopup)
      document.addEventListener("YGPopup:open", this.clickOpenPopup)
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      document.removeEventListener('YGPopupBox:open', this.handleOpenEvent);
    }

    clickOpenPopup(event) {
      const {$popupTemplate, fn} = event.detail;
      this.openPopup($popupTemplate, fn);
    }

    clickClosePopup(e) {
      this.closePopup(e, () => {
      });
    }

    openPopup($popupTemplate, fn) {
      // popupTemplate：需要替换的元素
      if (!$popupTemplate || !this.$contentInner) return;
      this.$contentInner.innerHTML = $popupTemplate.innerHTML;
      document.body.style.overflow = 'hidden';
      this.style.display = 'flex';
      typeof fn === 'function' && fn();
    }

    closePopup(e, fn) {
      let closeClassName = ["yg-popup-box-close", "yg-popup-box"]
      if (closeClassName.some(className => e.target.classList.contains(className))) {
        this.style.display = 'none';
        this.$contentInner.innerHTML = '';
        document.body.style.overflow = 'auto';
        typeof fn === 'function' && fn();
      }
    }
  }

  if (!window.customElements.get('yg-popup-box')) {
    window.customElements.define('yg-popup-box', YGPopupBox);
  }

class YGOpenPopup extends HTMLElement {
  constructor() {
    super();
    this.itemClick = this.itemClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.itemClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.itemClick);
  }

  itemClick() {
    let $popupTemplate = this.querySelector('template') || this.querySelector('.yg-popup-template');

    console.log("$popupTemplate: ", $popupTemplate)
    if ($popupTemplate) {
      document.dispatchEvent(new CustomEvent("YGPopup:open", {
        bubbles: true,
        detail: {
          $popupTemplate,
          fn: () => {
          }
        }
      }))
    }
  }
}

if (!window.customElements.get('yg-open-popup')) {
  window.customElements.define('yg-open-popup', YGOpenPopup);
}
